import MobileStores from "./mobile-stores";
export default MobileStores;
